/* eslint-disable */
// IRS life-expectancy tables and divisor helpers.
const UNIFORM_LIFETIME_TABLE = {
  72: 27.4, 73: 26.5, 74: 25.5, 75: 24.6, 76: 23.7, 77: 22.9,
  78: 22.0, 79: 21.1, 80: 20.2, 81: 19.4, 82: 18.5, 83: 17.7,
  84: 16.8, 85: 16.0, 86: 15.2, 87: 14.4, 88: 13.7, 89: 12.9,
  90: 12.2, 91: 11.5, 92: 10.8, 93: 10.1, 94: 9.5,  95: 8.9,
  96: 8.4,  97: 7.8,  98: 7.3,  99: 6.8,  100: 6.4, 101: 6.0,
  102: 5.6, 103: 5.2, 104: 4.9, 105: 4.6, 106: 4.3, 107: 4.1,
  108: 3.9, 109: 3.7, 110: 3.5, 111: 3.4, 112: 3.3, 113: 3.1,
  114: 3.0, 115: 2.9, 116: 2.8, 117: 2.7, 118: 2.5, 119: 2.3,
  120: 2.0
};

const SINGLE_LIFE_TABLE = {
  0:84.6,1:83.7,2:82.8,3:81.8,4:80.8,5:79.8,6:78.8,7:77.9,8:76.9,9:75.9,
  10:74.9,11:73.9,12:72.9,13:71.9,14:70.9,15:69.9,16:69,17:68,18:67,19:66,
  20:65,21:64.1,22:63.1,23:62.1,24:61.1,25:60.2,26:59.2,27:58.2,28:57.3,29:56.3,
  30:55.3,31:54.4,32:53.4,33:52.5,34:51.5,35:50.5,36:49.6,37:48.6,38:47.7,39:46.7,
  40:45.7,41:44.8,42:43.8,43:42.9,44:41.9,45:41,46:40,47:39,48:38.1,49:37.1,
  50:36.2,51:35.3,52:34.3,53:33.4,54:32.5,55:31.6,56:30.6,57:29.8,58:28.9,59:28,
  60:27.1,61:26.2,62:25.4,63:24.5,64:23.7,65:22.9,66:22,67:21.2,68:20.4,69:19.6,
  70:18.8,71:18,72:17.2,73:16.4,74:15.6,75:14.8,76:14.1,77:13.3,78:12.6,79:11.9,
  80:11.2,81:10.5,82:9.9,83:9.3,84:8.7,85:8.1,86:7.6,87:7.1,88:6.6,89:6.1,
  90:5.7,91:5.3,92:4.9,93:4.6,94:4.3,95:4,96:3.7,97:3.4,98:3.2,99:3,
  100:2.8,101:2.6,102:2.5,103:2.3,104:2.2,105:2.1,106:2.1,107:2.1,108:2,109:2,
  110:2,111:2,112:2,113:1.9,114:1.9,115:1.8,116:1.8,117:1.6,118:1.4,119:1.1,120:1
};

// ─── CALCULATION FUNCTIONS ───────────────────────────────────────────────────
function getDistributionPeriod(age) {
  if (UNIFORM_LIFETIME_TABLE[age]) return UNIFORM_LIFETIME_TABLE[age];
  if (age > 120) return 2.0;
  return 0.001;
}

function getSingleLifePeriod(age) {
  if (SINGLE_LIFE_TABLE[age]) return SINGLE_LIFE_TABLE[age];
  if (age > 120) return 1.0;
  return 0.001;
}

function getRMDRequiredAge(birthYear) {
  if (birthYear >= 1960) return 75;
  if (birthYear >= 1951) return 73;
  return 72;
}

export { UNIFORM_LIFETIME_TABLE, SINGLE_LIFE_TABLE, getDistributionPeriod, getSingleLifePeriod, getRMDRequiredAge };
